<template>
    <modal
        title="Modification du jalon"
        @close="cancel()">
        <div class="jalon-details">

            <div v-if="mode === 'delete'" class="delete">
                <strong>Êtes-vous sûr de bien vouloir supprimer {{returnJalonMessage()}}</strong>
            </div>

            <div class="buttons">
                <div class="btn btn-default" v-on:click="toggleDelete()">Annuler</div>
                <div class="btn btn-primary" v-on:click="doDelete()">Supprimer</div>
            </div>

        </div>

    </modal>
</template>

<script>
  import _ from 'lodash'
  import Modal from '../../modals/ModalBasic'

  export default {
    data () {
      return {
        mode: 'delete',
      }
    },
    props: [
      'hideDispatchAction',
      'intervention',
      'ronde',
    ],
    computed: {
      loading: function () {
        return this.$store.state.rondes.deleteDebutFinJalonModal.loading
      },
    },
    components: {
      Modal,
    },
    methods: {
      cancel: function () {
        this.$store.dispatch(this.hideDispatchAction)
      },
      toggleDelete () {
        this.$store.dispatch(this.hideDispatchAction)
      },
      doDelete () {
        this.$store.dispatch('removeInterventionV2', {
          intervention: _.cloneDeep(this.intervention),
          ronde: _.cloneDeep(this.ronde.data),
        })
      },
      returnJalonMessage: function () {
        if (this.intervention.jalon.type === "Début de jalon") {
          return 'ce début de jalon ?'
        } else {
          return 'cette fin de jalon ?'
        }
      },
    },
  }
</script>

<style lang="scss">
  @import "../../../scss/variables";

  .jalon-details {

    min-width: 840px;

    .delete {
      text-align: center;
      padding: 5rem;
    }
  }
</style>



// WEBPACK FOOTER //
// RondeDebutFinJalonDeleteModal.vue?327b3806